import { render } from "./SelectParticipant.vue?vue&type=template&id=556b394e&scoped=true"
import script from "./SelectParticipant.vue?vue&type=script&lang=js"
export * from "./SelectParticipant.vue?vue&type=script&lang=js"

import "./SelectParticipant.vue?vue&type=style&index=0&id=556b394e&scoped=true&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556b394e"]])

export default __exports__